<div class="mini-header">
  <mat-card class="d-flex pr-user mx-0 px-0">
    <a mat-icon-button [routerLink]="['scrolls']" class="mx-1" color="primary">
      <mat-icon>keyboard_backspace</mat-icon>
    </a>
    <div class="pr-avatar1 rounded-circle pr-cursor">
      <img [src]="profileUser?.profileData?.photoURL || './assets/images/profile.jpg'" class="">
    </div>
    <div>
      <h5 class="pr-name mr-1 mh-truncate">{{profileUser?.profileData?.name}}</h5>
      <span class="text-success mh-truncate">@{{profileUser?.handle}}</span>
    </div>

    <div class="ml-auto pr-actions mr-1">
      <button mat-stroked-button routerLink="edit" color="primary" class="mr-2" matTooltip="Edit Profile"
        *ngIf="currentUser?.ID === profileUser?.ID">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-stroked-button routerLink="settings" color="primary" matTooltip="Profile Settings"
        *ngIf="currentUser?.ID === profileUser?.ID">
        <mat-icon>settings</mat-icon>
      </button>
      <span *ngIf="currentUser?.ID !== profileUser?.ID">
        <button mat-stroked-button color="primary" (click)="followUser()" *ngIf="!profileUser?.ifollow">Follow</button>
        <button mat-raised-button color="primary" (click)="unFollowUser()" class="pr-following"
          *ngIf="profileUser?.ifollow"><span>Following</span></button>
      </span>
      <button mat-icon-button class="mr-1 pr-mini-actions" [matMenuTriggerFor]="prActions"
        *ngIf="currentUser?.ID !== profileUser?.ID">
        <mat-icon>filter_list</mat-icon>
      </button>
      <mat-menu #prActions="matMenu">
        <button mat-menu-item>
          <mat-icon>cancel</mat-icon>
          <span>Block</span>
        </button>
        <button mat-menu-item>
          <mat-icon>report_problem</mat-icon>
          <span>Report</span>
        </button>
        <button mat-menu-item *ngIf="false">
          <mat-icon>share</mat-icon>
          <span>Share</span>
        </button>
      </mat-menu>
    </div>
  </mat-card>
</div>